import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { auth } from "../firebaseConfig";
import "../App.css";

const HeaderForm = () => {
  const tipoComprobanteData = JSON.parse(localStorage.getItem("tipoComprobante"));
  const tipoDocumento = tipoComprobanteData?.tipoDocumento || "";

  const navigate = useNavigate();

  const [showHourglass, setShowHourglass] = useState(false);
  const [popupMessage, setPopupMessage] = useState("");
  const [showRedirectPopup, setShowRedirectPopup] = useState(false);
  const [formTouched, setFormTouched] = useState(false);
  const [errores, setErrores] = useState({});
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [showBackModal, setShowBackModal] = useState(false);   
  const [tipoSeleccionado, setTipoSeleccionado] = useState("");
  const [proveedor, setProveedor] = useState("");
  const cuit = localStorage.getItem("cuit") || "";
  const [exchangeRate, setExchangeRate] = useState("");

  const [headerData, setHeaderData] = useState({
    CF: "", CAI: "", CAE: "", CAEA: "", proveedor: "", numeroFactura: "",
    fechaEmision: "", fechaVencimiento: "", montoTotal: "", moneda: "",
    tipoNumero: "", numeroSeleccionado: "", fechaSeleccionada: "", tipoDocumento,
  });

  useEffect(() => {
    const fetchProveedor = async () => {
      try {
        const user = auth.currentUser;
        if (!user) return;
        const response = await fetch(`/api/get-proveedor?email=${user.email}`);
        const data = await response.json();
        if (data.proveedor) setProveedor(data.proveedor);
      } catch (error) {
        console.error("Error al obtener proveedor:", error);
      }
    };
    const saved = JSON.parse(localStorage.getItem("headerData"));
    if (saved) setHeaderData(saved);
    fetchProveedor();
  }, []);

  const handleChange = (e) => {
    setFormTouched(true);
    const { name, value } = e.target;
    setHeaderData((prevData) => ({ ...prevData, [name]: value }));

    // Si cambia la moneda y no es USD/EUR, borramos tipo de cambio
    if (name === "moneda" && (value !== "USD" && value !== "EUR")) {
      setExchangeRate("");
    }
  };

  const handleExchangeRateChange = (e) => {
    setFormTouched(true);
    setExchangeRate(e.target.value);
  };
  
  const handleTipoClick = (tipo) => {
    setFormTouched(true);
    setTipoSeleccionado(tipo);
    setHeaderData({ ...headerData, tipoNumero: tipo, numeroSeleccionado: "", fechaSeleccionada: "" });
  };

  const validarCampos = () => {
    const nuevosErrores = {};
  
    if (!headerData.fechaEmision) nuevosErrores.fechaEmision = true;
    if (!headerData.ptoventa) nuevosErrores.ptoventa = true;
    if (!headerData.numeroFactura) nuevosErrores.numeroFactura = true;
    if (!headerData.montoTotal) nuevosErrores.montoTotal = true;
    if (!headerData.moneda) nuevosErrores.moneda = true;
    if (tipoSeleccionado && !headerData.numeroSeleccionado) nuevosErrores.numeroSeleccionado = true;
    if (tipoSeleccionado && !headerData.fechaSeleccionada) nuevosErrores.fechaSeleccionada = true;

    setErrores(nuevosErrores);
  
    return Object.keys(nuevosErrores).length === 0;
  };
  
  const handleNext = async () => {
    if (!validarCampos()) {
      alert("❗ Por favor, complete todos los campos obligatorios.");
      return;
    }

    setShowHourglass(true);

    // Guardar tipo de cambio en localStorage si es necesario
    if (exchangeRate) {
      localStorage.setItem("exchangeRate", exchangeRate);
    }
  
    localStorage.setItem("headerData", JSON.stringify(headerData));
    
    try {
      const tipoDocumentoSheet = tipoDocumento === "Servicio" ? "dDocument_Service" : "dDocument_Items";  // dDocument_Service
      const hoja = tipoDocumento === "Servicio" ? "CAB_S" : "CAB_I";
      const tipoComprobanteCode = tipoComprobanteData?.comprobante || "";

      const response = await fetch("/api/saveInvoiceHeader", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          tipoComprobante: tipoComprobanteCode,
          tipoFactura: tipoComprobanteData?.tipoFactura,
          tipoDocumento: tipoDocumento,
          tipoDocumentoSheet,
          ordenCompra: tipoComprobanteData?.ordenCompra,
          numeroEntrega: tipoComprobanteData?.numeroEntrega,
          cuit,
          fechaEmision: headerData.fechaEmision,
          ptoventa: headerData.ptoventa,
          numeroFactura: headerData.numeroFactura,
          moneda: headerData.moneda,
          montoTotal: headerData.montoTotal,
          tipoNumero: headerData.tipoNumero,
          numeroSeleccionado: headerData.numeroSeleccionado,
          fechaSeleccionada: headerData.fechaSeleccionada,
          CF: tipoSeleccionado === "Controlador Fiscal" ? headerData[tipoSeleccionado] : "",
          CAI: tipoSeleccionado === "CAI" ? headerData[tipoSeleccionado] : "",
          CAE: tipoSeleccionado === "CAE" ? headerData[tipoSeleccionado] : "",
          CAEA: tipoSeleccionado === "CAEA" ? headerData[tipoSeleccionado] : "",
          tipoCambio: exchangeRate || "", // Agregar tipo de cambio si aplica
        }),
      });

      const result = await response.json();
      const invoiceNumber = result.numeroFactura;
      if (!invoiceNumber) throw new Error("No se pudo obtener número de factura");

      // 🔽 GUARDAR EN LOCALSTORAGE ACÁ
      localStorage.setItem("nextInvoiceNumber", invoiceNumber);
      localStorage.setItem("tipoDocumento", tipoDocumento);

      await checkEstadoFactura(invoiceNumber, hoja, tipoDocumento, headerData.fechaEmision);

    } catch (error) {
      console.error("Error al enviar header:", error);
      setShowHourglass(false);
      setPopupMessage("Ocurrió un error al enviar los datos. Intente nuevamente.");
      setShowRedirectPopup(true);
    }
  };

  const checkEstadoFactura = async (invoiceNumber, hoja, tipoDocumento, fechaEmision) => {
    try {
      let intentos = 0;
      const maxIntentos = 20;
      const intervalo = 6000;

      while (intentos < maxIntentos) {
        const response = await fetch(`/api/estadoFactura?hoja=${hoja}&numero=${invoiceNumber}`);
        const data = await response.json();

        if (data.estado === "Pendiente") {
          // ✅ Ahora, primero actualizar forma de pago
          await fetch("/api/updateCabeceraWithFormaPago", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ tipoDocumento, invoiceNumber }),
          });

          // ✅ Luego LEER la forma de pago recién actualizada desde el detalle
          const formaPagoResponse = await fetch("/api/getFormaPagoFromDetalle", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ tipoDocumento, invoiceNumber }),
          });
          const { formaPago } = await formaPagoResponse.json();

          // ✅ Luego actualizar fecha de vencimiento y valor de columna Q
          await fetch("/api/updateFechaVencimientoYValorQ", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ tipoDocumento, fechaEmision, formaPago, invoiceNumber }),
          });

          setShowHourglass(false);
          navigate("/confirm");
          return;
        }

        if (data.estado === "Sin Detalles") {
          await eliminarCabecera(invoiceNumber, hoja);
          const tipoDocFromStorage = localStorage.getItem("tipoDocumento");
          await eliminarPercepciones(invoiceNumber, tipoDocFromStorage);

          setShowHourglass(false);
          setPopupMessage("❗️ Lo sentimos, su Orden/Entrega aún no ha sido cargada. Intente más tarde.");
          setShowRedirectPopup(true);
          return;
        }
        

        await new Promise(resolve => setTimeout(resolve, intervalo));
        intentos++;
      }

      // Timeout
      setShowHourglass(false);
      setPopupMessage("⏳ Tiempo de espera agotado. Intente más tarde.");
      setShowRedirectPopup(true);

    } catch (error) {
      console.error("Error al consultar estado:", error);
      setShowHourglass(false);
      setPopupMessage("Error al verificar el estado de la factura.");
      setShowRedirectPopup(true);
    }
  };

  const eliminarCabecera = async (invoiceNumber, hoja) => {
    try {
      await fetch("/api/eliminarNumeroFactura", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ hoja, numero: invoiceNumber }),
      });
    } catch (error) {
      console.error("❌ Error al eliminar número de factura:", error);
    }
  };
  
  const eliminarPercepciones = async (invoiceNumber, tipoDocumento) => {
    try {
      await fetch("/api/eliminarPercepciones", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ invoiceNumber, tipoDocumento }),
      });
    } catch (error) {
      console.error("❌ Error al eliminar percepciones:", error);
    }
  };
  

  const confirmBack = async () => {
    const invoiceNumber = localStorage.getItem("nextInvoiceNumber");
    const tipoDocFromStorage = localStorage.getItem("tipoDocumento");


  
    try {
      await eliminarPercepciones(invoiceNumber, tipoDocFromStorage);
      console.log("🧾 Número de factura y percepciones eliminados correctamente");
    } catch (error) {
      console.error("❌ Error al eliminar datos al volver:", error);
    }
  
    setShowBackModal(false);
    navigate("/tipo-comprobante");
  };
  
  return (
    <div className="headerform-container">
    <h3 className="comprobante-title">Cabecera de la Factura</h3>

    <form onSubmit={(e) => e.preventDefault()}>
      <div className="form-row">
        <div className="input-column">
          <input
            type="text"
            value={proveedor}
            readOnly
            className="input-field"
          />
          <small className="field-description">Nombre del proveedor (se completa automáticamente).</small>
        </div>

        <div className="input-column">
          <input
            type="date"
            name="fechaEmision"
            onChange={handleChange}
            required
            className={`input-field ${errores.fechaEmision ? "error" : ""}`}
          />
          <small className="field-description">Fecha en la que se emitió la factura.</small>
        </div>
      </div>

      <div className="form-row">
        <div className="input-column">
          <input
            type="number"
            name="ptoventa"
            placeholder="Pto Venta"
            onChange={handleChange}
            required
            className={`input-field ${errores.ptoventa ? "error" : ""}`}
          />
          <small className="field-description">Número del punto de venta (ej: 1, 2, 3...).</small>
        </div>

        <div className="input-column">
          <input
            type="number"
            name="numeroFactura"
            placeholder="Número de Factura"
            onChange={handleChange}
            required
            className={`input-field ${errores.numeroFactura ? "error" : ""}`}
          />
          <small className="field-description">Número correlativo del comprobante (últimos 5 dígitos).</small>
        </div>
      </div>

      <div className="form-row">
        <div className="input-column">
          <input
            type="number"
            name="montoTotal"
            placeholder="Monto Total"
            onChange={handleChange}
            required
            className={`input-field ${errores.montoTotal ? "error" : ""}`}
          />
          <small className="field-description">Importe total de la factura (con IVA).</small>
        </div>

        <div className="input-column">
          <select
            name="moneda"
            onChange={handleChange}
            value={headerData.moneda}
            required
            className={`input-field ${errores.moneda ? "error" : ""}`}
          >
            <option value="">Seleccione Moneda</option>
            <option value="ARS">ARS</option>
            <option value="USD">USD</option>
            <option value="EUR">EUR</option>
          </select>
          <small className="field-description">Moneda en la que está expresado el monto.</small>
        </div>

        {["USD", "EUR"].includes(headerData.moneda) && (
          <div className="input-column">
            <input
              type="number"
              name="exchangeRate"
              placeholder="Tipo de Cambio"
              value={exchangeRate}
              onChange={handleExchangeRateChange}
              required
              className={`input-field ${errores.exchangeRate ? "error" : ""}`}
            />
            <small className="field-description">Tipo de cambio del día en que se emitió.</small>
          </div>
        )}
      </div>
    </form>
  
      {/* TIPO DE COMPROBANTE */}
      <div className="button-group">
        {["Controlador Fiscal", "CAI", "CAE", "CAEA"].map((tipo) => (
          <button
            key={tipo}
            className={tipoSeleccionado === tipo ? "selected" : ""}
            onClick={() => handleTipoClick(tipo)}
          >
            {tipo}
          </button>
        ))}
      </div>
  
      {tipoSeleccionado && (
        <>
          <div className="form-row">
            <input
              type="text"
              name="numeroSeleccionado"
              placeholder={`N° ${tipoSeleccionado}`}
              value={headerData.numeroSeleccionado}
              onChange={handleChange}
              required
              className={`input-field ${errores.numeroSeleccionado ? "error" : ""}`}
            />
          </div>
          <div className="form-row">
            <input
              type="date"
              name="fechaSeleccionada"
              value={headerData.fechaSeleccionada}
              onChange={handleChange}
              required
              className={`input-field ${errores.fechaSeleccionada ? "error" : ""}`}
            />
          </div>
        </>
      )}
      
      <div className="button-container">
        <button className="secondary-button" onClick={() => {
          if (formTouched) {
            setShowConfirmModal(true);
          } else {
            navigate("/tipo-comprobante");
          }
        }}>
          Volver
        </button>
        <button className="primary-button" onClick={handleNext}>
          Siguiente
        </button>
      </div>

      {/* POPUPS */}
      {showHourglass && <HourglassPopup />}
      {showRedirectPopup && (
        <RedirectPopup
          message={popupMessage}
          onClose={() => {
            setShowRedirectPopup(false);
            navigate("/tipo-comprobante"); // ✅ Redirige al cerrar
          }}
        />
      )}

      {showConfirmModal && (
        <div className="modal-overlay">
          <div className="modal-content animated-popup">
            <div className="warning-icon">⚠️</div>
            <p>¿Deseás volver? Se perderán los datos ingresados.</p>
            <div className="modal-buttons">
              <button className="yes-btn" onClick={confirmBack}>Sí, volver</button>
              <button className="no-btn" onClick={() => setShowConfirmModal(false)}>Cancelar</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

// 🕒 Reloj de arena animado
const HourglassPopup = () => (
  <div className="modal-overlay">
    <div className="modal-content animated-popup">
      <div className="hourglass">⏳</div>
      <p>Procesando factura...</p>
    </div>
  </div>
);

// ❗ Modal de redirección
const RedirectPopup = ({ message, onClose }) => (
  <div className="modal-overlay">
    <div className="modal-content animated-popup">
      <div className="warning-icon">⚠️</div>
      <p>{message}</p>
      <div className="modal-buttons">
        <button className="yes-btn" onClick={onClose}>Aceptar</button>
      </div>
    </div>
  </div>
);

export default HeaderForm;



